// Modules
import xhr from 'modules/xhr';
// API
import { ENDPOINTS } from '../api.config';
// Interfaces and types
import {
  IGetIncidentsRes,
  IGetIncidentDetailsRes,
  IDeleteIncidentsParams,
  IDeleteIncidentsRes,
  IUpdateIncidentsBodyWithParams,
  IUpdateIncidentsRes,
  ICreateIncidentFileRes,
} from 'types/incidentTypes';
import { IResMessage, TQueryParams } from 'types/appTypes';

export const getIncidents = (params: TQueryParams) => {
  return xhr.get<IGetIncidentsRes, IGetIncidentsRes>(`${ENDPOINTS.incidents}`, {
    params,
  });
};

export const getIncidentDetails = (id: number) => {
  return xhr.get<IGetIncidentDetailsRes, IGetIncidentDetailsRes>(
    `${ENDPOINTS.incidents}/${id}`,
  );
};

export const updateIncidentsDetails = ({ id, body }: IUpdateIncidentsBodyWithParams) => {
  return xhr.patch<IUpdateIncidentsRes, IUpdateIncidentsRes>(
    `${ENDPOINTS.incidents}/${id}`,
    body,
  );
};

export const deleteIncidentsDetails = ({ id }: IDeleteIncidentsParams) => {
  return xhr.delete<IDeleteIncidentsRes, IDeleteIncidentsRes>(`${ENDPOINTS.incidents}/${id}`);
};

export const addIncidentFile = (file: FormData) => {
  return xhr.post<ICreateIncidentFileRes, ICreateIncidentFileRes>(
    `${ENDPOINTS.incidentFiles}`,
    file,
  );
};

export const deleteIncidentFile = (id: string) => {
  return xhr.delete<IResMessage, IResMessage>(`${ENDPOINTS.incidentFiles}/${id}`);
};
